import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Chip } from 'react-toolbox'
import { Flex } from 'reflexbox'

import MemoryConfig from './MemoryConfig'
import CheckboxFilter from 'components/custom/CheckboxFilter/index'
import AddPopupDialog from 'components/custom/AddPopupDialog/index'
import AddPopup from 'components/custom/AddPopup/index'

import styles from './styles.scss'

import {TableCell} from 'react-toolbox/lib/table'

class Memory extends Component {
  componentDidMount() {
    // add configuration string to default memory parts
    this.props.initConfig()
  }

  render() {
    const {
      sources,
      approvedSources,
      riskSources,
      values,
      togglePopup,
      configSelection,
      configSource,
      curConfig,
      isAddPart,
      onClockChange,
      onTogglePopup,
      onPartTypeChange,
      onDensityChange,
      onOrgSizeChange,
      onOrgWidthChange,
      onChannelChange,
      onConfigChange,
      onUpdateConfig,
      onUpdateConfigSource,
      onAddPart,
      onDeletePart,
      onUpdateCurConfig,
      onRefreshFilter,
      setIsAddPart,
      initConfigFilter,
      initFilters,
      channelFilter,
      densityFilter,
      orgSizeFilter,
      orgWidthFilter,
      partTypeFilter,
      configFilter,
      filterPairs,
      approvedFilterPairs,
      riskFilterPairs,
    } = this.props

    const filterHandlers = {
      partType: onPartTypeChange,
      density: onDensityChange,
      organizationSize: onOrgSizeChange,
      organizationWidth: onOrgWidthChange,
      channel: onChannelChange,
      config: onConfigChange,
    }

    this.filterStatus = {
      partType: partTypeFilter,
      density: densityFilter,
      organizationSize: orgSizeFilter,
      organizationWidth: orgWidthFilter,
      channel: channelFilter,
      config: configFilter,
    }

    // const configModel = {
    //   vendorName: {header: <div></div>, title: 'Vendor Name'},
    //   partNumber: {header: <div></div>, title: 'Part Number'},
    //   speedGrade: {header: <div></div>, title: 'Speed Grade'},
    // }

    const tableHeadContent = {
        vendorName: (<TableCell key={0}>Vendor Name</TableCell>),
        partNumber: (<TableCell key={1}>Part Number</TableCell>),
        speedGrade: (<TableCell key={2}>Speed Grade</TableCell>)
    }

    const chipComponent =
      <Chip theme={styles}>
        <span>Non-RVL</span>
      </Chip>

    return (
      <Flex styleName="MemoryWrapper">
        <MemoryConfig
          values={values}
          togglePopup={togglePopup}
          onClockChange={onClockChange}
          onTogglePopup={onTogglePopup}
          onDeletePart={onDeletePart}
          onUpdateCurConfig={onUpdateCurConfig}
          curConfig={curConfig}
          filterPairs={filterPairs}
          setIsAddPart={setIsAddPart}
          initConfigFilter={initConfigFilter}
          initFilters={initFilters}
        />
        {
          isAddPart ?
          <AddPopupDialog
            togglePopup={togglePopup}
            tabTitles={['Memory Configuration']}
            onTogglePopup={onTogglePopup}
            onUpdateConfig={onUpdateConfig}
            onUpdateConfigSource={onUpdateConfigSource}
            onRefreshFilter={onRefreshFilter}
          >
            <AddPopup
              sources={sources}
              configSelection={configSelection}
              configSource={configSource}
              curConfig={curConfig}
              onAddPart={onAddPart}
              onTogglePopup={onTogglePopup}
              onUpdateConfig={onUpdateConfig}
              onUpdateConfigSource={onUpdateConfigSource}
              onRefreshFilter={onRefreshFilter}
              filterStatus={this.filterStatus}
              tableHeadContent={tableHeadContent}
              multiSelectable={true}
              enableRvl={true}
            >
              <CheckboxFilter
                sources={sources}
                curConfig={curConfig}
                filterHandlers={filterHandlers}
                filterStatus={this.filterStatus}
                onUpdateConfig={onUpdateConfig}
                onUpdateConfigSource={onUpdateConfigSource}
                onRefreshFilter={onRefreshFilter}
                filterPairs={approvedFilterPairs}
              />
              { chipComponent }
            </AddPopup>
          </AddPopupDialog> :
          <AddPopupDialog
            togglePopup={togglePopup}
            tabTitles={['Approved Memory Configuration', 'Risk Memory Configuration']}
            onTogglePopup={onTogglePopup}
            onUpdateConfig={onUpdateConfig}
            onUpdateConfigSource={onUpdateConfigSource}
            onRefreshFilter={onRefreshFilter}
          >
            <AddPopup
              sources={approvedSources}
              configSelection={configSelection}
              configSource={configSource}
              curConfig={curConfig}
              onAddPart={onAddPart}
              onTogglePopup={onTogglePopup}
              onUpdateConfig={onUpdateConfig}
              onUpdateConfigSource={onUpdateConfigSource}
              onRefreshFilter={onRefreshFilter}
              filterStatus={this.filterStatus}
              tableHeadContent={tableHeadContent}
              multiSelectable={true}
              enableRvl={true}
            >
              <CheckboxFilter
                sources={approvedSources}
                curConfig={curConfig}
                filterHandlers={filterHandlers}
                filterStatus={this.filterStatus}
                onUpdateConfig={onUpdateConfig}
                onUpdateConfigSource={onUpdateConfigSource}
                onRefreshFilter={onRefreshFilter}
                filterPairs={approvedFilterPairs}
              />
              { chipComponent }
            </AddPopup>
            <AddPopup
              sources={riskSources}
              configSelection={configSelection}
              configSource={configSource}
              curConfig={curConfig}
              onAddPart={onAddPart}
              onTogglePopup={onTogglePopup}
              onUpdateConfig={onUpdateConfig}
              onUpdateConfigSource={onUpdateConfigSource}
              onRefreshFilter={onRefreshFilter}
              filterStatus={this.filterStatus}
              tableHeadContent={tableHeadContent}
              multiSelectable={true}
              enableRvl={true}
            >
              <CheckboxFilter
                sources={riskSources}
                curConfig={curConfig}
                filterHandlers={filterHandlers}
                filterStatus={this.filterStatus}
                onUpdateConfig={onUpdateConfig}
                onUpdateConfigSource={onUpdateConfigSource}
                onRefreshFilter={onRefreshFilter}
                filterPairs={riskFilterPairs}
              />
              { chipComponent }
            </AddPopup>
          </AddPopupDialog>
        }
      </Flex>
    )
  }
}

export default CSSModules(Memory, styles)
